export default "__VITE_ASSET__0grlzSE9__"